import { extractMessage } from "helpers/extractError";
import { generateRandomID } from "helpers/generateRandomID";
import moment from "moment";

export const START_REQUEST_SEARCH = 'START_REQUEST_SEARCH';
export const STOP_REQUEST_SEARCH = 'STOP_REQUEST_SEARCH';
export const BUILD_COMP_LOADINGS_SEARCH = 'BUILD_COMP_LOADINGS_SEARCH';
export const BUILD_TABLE_CONFIG = 'BUILD_TABLE_CONFIG';
export const BUILD_CUSTOM_TABLE_CONFIG = 'BUILD_CUSTOM_TABLE_CONFIG';
export const SET_CONFIG_TABLE_PAGE_SIZE = 'SET_CONFIG_TABLE_PAGE_SIZE';
export const SET_CONFIG_TABLE_PAGE = 'SET_CONFIG_TABLE_PAGE';
export const SET_CONFIG_TABLE_SORT = 'SET_CONFIG_TABLE_SORT';
export const SET_CONFIG_TABLE_FILTER = 'SET_CONFIG_TABLE_FILTER';
export const RESTORE_SINGLE_CONFIG_TABLE = 'RESTORE_SINGLE_CONFIG_TABLE';
export const DESTROY_CONFIG_TABLES = 'DESTROY_CONFIG_TABLES';

export const START_REQUEST_COMP_SEARCH = 'START_REQUEST_COMP_SEARCH';
export const STOP_REQUEST_COMP_SEARCH = 'STOP_REQUEST_COMP_SEARCH';
export const SET_SNACKBAR_SEARCH = 'SET_SNACKBAR_SEARCH';
export const CLEAR_SNACKBAR_SEARCH = 'CLEAR_SNACKBAR_SEARCH';
export const REMOVE_SNACKBAR_SEARCH = 'REMOVE_SNACKBAR_SEARCH';
export const CHANGE_UNITS_SEARCH = 'CHANGE_UNITS_SEARCH';
export const CHANGE_STATIONS_SEARCH = 'CHANGE_STATIONS_SEARCH';
export const CHANGE_DIFF_SEARCH = 'CHANGE_DIFF_SEARCH';
export const CHANGE_START_DATE_SEARCH = 'CHANGE_START_DATE_SEARCH';
export const CHANGE_END_DATE_SEARCH = 'CHANGE_END_DATE_SEARCH';
export const CLEAR_SEARCH = 'CLEAR_SEARCH';

const INITIAL_STATE = {
    isLoading: false,
    isLoadingComp: false,
    configTables: {},
    defaultPageSize: 20,
    // snackbar
    color: 'danger',
    message: '',
    isOpen: false,
    position: 'tr',
    snackbars: [],

    // filters
    stationsSelected: [],
    unitsSelected: [],
    diffSelected: [],

    // dates
    startDate: moment(),
    endDate: moment(),

}

export const searchReducer = (state = INITIAL_STATE, { type, payload }) => {
    switch (type) {
        case START_REQUEST_SEARCH:
            return {
                ...state,
                isLoading: true,
            }
        case STOP_REQUEST_SEARCH:
            return {
                ...state,
                isLoading: false,
            }
        case BUILD_TABLE_CONFIG:
            return {
                ...state,
                configTables: {
                    ...state.configTables,
                    [payload?.name]: {
                        pageSize: payload?.pageSize,
                        page: 0,
                        sorted: [],
                        filtered: [],
                    }
                }
            }
        case BUILD_CUSTOM_TABLE_CONFIG:
          return {
            ...state,
            configTables: {
              ...state.configTables,
              [payload.table]: {
                ...payload.tableConfig,
              },
            },
          };        
        case SET_CONFIG_TABLE_PAGE_SIZE:
            return {
                ...state,
                configTables: {
                    ...state.configTables,
                    [payload.table]: {
                        ...state.configTables[payload.table],
                        pageSize: payload.pageSize,
                        page: 0
                    }
                }
            }

        case SET_CONFIG_TABLE_PAGE:
            return {
                ...state,
                configTables: {
                    ...state.configTables,
                    [payload.table]: {
                        ...state.configTables[payload.table],
                        page: payload.page
                    }
                }
            }

        case SET_CONFIG_TABLE_SORT:
            return {
                ...state,
                configTables: {
                    ...state.configTables,
                    [payload.table]: {
                        ...state.configTables[payload.table],
                        sorted: payload.sorted,
                        page: 0
                    }
                }
            }

        case SET_CONFIG_TABLE_FILTER:
            return {
                ...state,
                configTables: {
                    ...state.configTables,
                    [payload.table]: {
                        ...state.configTables[payload.table],
                        filtered: payload.filtered,
                        page: 0
                    }
                }
            }
        case RESTORE_SINGLE_CONFIG_TABLE:
            return {
                ...state,
                configTables: {
                    ...state.configTables,
                    [payload]: {
                        pageSize: state.defaultPageSize,
                        page: 0,
                        sorted: [],
                        filtered: [],
                    }
                }
            }
        case DESTROY_CONFIG_TABLES:
            return {
                ...state,
                configTables: {},
            }

        case BUILD_COMP_LOADINGS_SEARCH: {
            const loadings = {}
            payload.forEach(loadingName => {
                return loadings[loadingName] = false;
            })
            return {
                ...state,
                isLoadingComp: loadings
            }
        }
        case START_REQUEST_COMP_SEARCH:
            return {
                ...state,
                isLoadingComp: {
                    ...state.isLoadingComp,
                    [payload]: true
                },
            }
        case STOP_REQUEST_COMP_SEARCH:
            return {
                ...state,
                isLoadingComp: {
                    ...state.isLoadingComp,
                    [payload]: false
                },
            }
        // snackbar
        case SET_SNACKBAR_SEARCH: {
            const newSnackbar = {
                id: generateRandomID(),
                message: extractMessage(payload?.message) || 'Error en el servicio, contacte a Soporte para mas información',
                color: payload.color,
                position: payload?.position || 'tr',
            };
            const MAX_SNACKBARS = 5;
            const updatedSnackbars = [...state.snackbars, newSnackbar].slice(-MAX_SNACKBARS);
            return {
                ...state,
                // Legacy flat props kept for backward compatibility (consumers still read these).
                // TODO: remove once all consumers migrate to snackbars[] array.
                message: newSnackbar.message,
                color: newSnackbar.color,
                isOpen: true,
                position: newSnackbar.position,
                snackbars: updatedSnackbars,
            };
        }
        case CLEAR_SNACKBAR_SEARCH:
            return {
                ...state,
                message: '',
                isOpen: false,
                snackbars: [],
            }
        case REMOVE_SNACKBAR_SEARCH: {
            const filtered = state.snackbars.filter((s) => s.id !== payload);
            // Legacy: filtered[0] used for backward compat — oldest remaining snackbar populates flat props.
            return {
                ...state,
                snackbars: filtered,
                message: filtered[0]?.message || '',
                color: filtered[0]?.color || 'danger',
                position: filtered[0]?.position || 'tr',
                isOpen: filtered.length > 0,
            }
        }
        // filter
        case CHANGE_UNITS_SEARCH:
            return {
                ...state,
                unitsSelected: payload,
            };
        case CHANGE_STATIONS_SEARCH:
            return {
                ...state,
                stationsSelected: payload,
            };
        case CHANGE_DIFF_SEARCH:
            return {
                ...state,
                diffSelected: payload,
            };
        case CHANGE_START_DATE_SEARCH:
            return {
                ...state,
                startDate: payload,
            };
        case CHANGE_END_DATE_SEARCH:
            return {
                ...state,
                endDate: payload,
            };
        // clear
        case CLEAR_SEARCH:
            return {
                ...state,
                ...INITIAL_STATE,
            };
        default:
            return state;
    }
}
